var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surroundBox',{attrs:{"name":_vm.description,"desc":"废弃物加工后得到的产品"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"chart-box-1"},[_c('div',{staticClass:"tag-box",attrs:{"id":"tag-box"}},[_c('div',{staticClass:"beg test"}),_c('div',{staticClass:"beg center-beg"})])])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }